// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text } from 'pixi.js';
import { RaceEventTitleLocalizationsLayout } from '../raceEvent/RaceEventTitleLocalizationsLayout';
import { WinStreakLocalizedLogoLayout } from '../winStreak/WinStreakLocalizedLogoLayout';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: 'dynamicProps_SPL',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: {
        dynamicValues: {
          y: 'height * -0.5'
        }
      }
    },
    {
      id: 'af6f3799-3a49-4ff4-bc92-dfda74845e33',
      type: 'Sprite',
      name: 'blackBackground',
      className: 'dynamicProps_SPL',
      x: 0,
      y: -20,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 12.1875,
        y: 20
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 0,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Collect_Event_Square_White',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        dynamicValues: {
          width: 'width * 1.2',
          height: 'height * 1.2'
        }
      }
    },
    {
      id: '0b3b1262-fac0-4268-99a4-c27f5ea8f83f',
      type: 'Container',
      name: 'content',
      className: 'dynamicProps_SPL',
      x: 0,
      y: 640,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        dynamicValues: {
          y: 'height * 0.5'
        }
      }
    },
    {
      id: '70446b37-85f8-4861-90bf-5e5cf8190643',
      type: 'Container',
      name: 'adCountdownSlot',
      className: 'dynamicProps_SPL',
      x: 0,
      y: 70,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        dynamicValues: {
          x: 'width * -0.5 + 20'
        }
      }
    },
    {
      id: '412f8bd1-7648-4e0f-93cd-409afd55830d',
      type: 'Sprite',
      name: 'genericImage',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: '',
      parent: '0b3b1262-fac0-4268-99a4-c27f5ea8f83f',
      stateByName: {
        race: {
          texture: 'Backstop_Race_Event_Image'
        },
        winStreak: {
          texture: 'Backstop_Win_Streak_Road_Image'
        },
        collectingEvent: {
          texture: 'Backstop_Collecting_Event_Image'
        },
        generic: {
          texture: 'Backstop_Generic_Image'
        }
      }
    },
    {
      id: 'da4c5a32-6468-433b-8336-0967bd60c9a6',
      type: 'Text',
      name: 'genericText',
      className: '',
      x: 0,
      y: 518,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Embrace the challenge!',
      localize: true,
      maxWidth: 600,
      maxHeight: 150,
      maxFontSize: 48,
      icons: [],
      style: {
        fontSize: 48,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 600,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '0b3b1262-fac0-4268-99a4-c27f5ea8f83f',
      data: {
        translations: {
          'Have you collected all 4?': {
            en_US: 'Have you collected all 4?',
            it_IT: 'Li hai raccolti tutti e 4?',
            fr_FR: 'Les as-tu tous collectés ?',
            de_DE: 'Hast du alle 4 gesammelt?',
            es_ES: '¿Has conseguido los 4?',
            pt_PT: 'Já recolheste os 4?',
            pl_PL: 'Czy zebrałeś wszystkie 4?',
            nl_NL: 'Heb je ze alle 4 verzameld?',
            ko_KR: '4개를 모두 모았나요?',
            ja_JP: '4つすべて集めた？'
          },
          'How far can you travel on Win Streak Road?': {
            en_US: 'How far can you travel on Win Streak Road?',
            it_IT: 'Quanto lontano puoi arrivare sul Percorso delle Vittorie Consecutive?',
            fr_FR: 'Jusqu’où peux-tu aller sur la Route des Victoires Consécutives ?',
            de_DE: 'Wie weit kommst du auf dem Siegesserien-Pfad?',
            es_ES: '¿Hasta dónde puedes llegar en la Ruta de Rachas de Victoria?',
            pt_PT: 'Até onde consegues ir no Caminho da Sequência de Vitórias?',
            pl_PL: 'Jak daleko możesz zajść na Drodze Zwycięskiej Passy?',
            nl_NL: 'Hoe ver kun jij komen op de Weg van de Winreeks?',
            ko_KR: '연승의 길에서 어디까지 갈 수 있을까?',
            ja_JP: '連勝ロードでどこまで進める？'
          },
          'Can you race to first place?': {
            en_US: 'Can you race to first place?',
            it_IT: 'Riuscirai a raggiungere il primo posto?',
            fr_FR: 'Peux-tu atteindre la première place ?',
            de_DE: 'Schaffst du es auf den ersten Platz?',
            es_ES: '¿Puedes llegar al primer puesto?',
            pt_PT: 'Consegues chegar ao primeiro lugar?',
            pl_PL: 'Czy uda ci się dotrzeć na pierwsze miejsce?',
            nl_NL: 'Kun jij de eerste plaats bereiken?',
            ko_KR: '1위에 도달할 수 있을까?',
            ja_JP: '1位にたどり着ける？'
          },
          'Embrace the challenge!': {
            en_US: 'Embrace the challenge!',
            it_IT: 'Abbraccia la sfida!',
            fr_FR: 'Relève le défi !',
            de_DE: 'Nimm die Herausforderung an!',
            es_ES: 'Acepta el desafío!',
            pt_PT: 'Aceita o desafio!',
            pl_PL: 'Podejmij wyzwanie!',
            nl_NL: 'Ga de uitdaging aan!',
            ko_KR: '도전을 받아들여라!',
            ja_JP: '挑戦を受け入れよう！'
          }
        }
      },
      stateByName: {
        race: {
          text: 'Can you race to first place?'
        },
        winStreak: {
          text: 'How far can you travel on Win Streak Road?'
        },
        collectingEvent: {
          text: 'Have you collected all 4?'
        },
        generic: {
          text: 'Embrace the challenge!'
        }
      }
    },
    {
      id: '610e3225-edcd-4f21-859c-878c7aabdc2b',
      type: 'Layout',
      name: 'raceLocalizedTitle',
      className: '',
      path: 'raceEvent/RaceEventTitleLocalizationsLayout.ts',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 0,
      y: -446,
      scale: {
        x: 1.4,
        y: 1.4
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: '0b3b1262-fac0-4268-99a4-c27f5ea8f83f',
      stateByName: {
        generic: {
          visible: false
        },
        winStreak: {
          visible: false
        },
        collectingEvent: {
          visible: false
        }
      }
    },
    {
      id: '3ddf503c-e250-4497-877f-bcdc6a94ce23',
      type: 'Layout',
      name: 'winStreakLocalizedTitle',
      className: '',
      path: 'winStreak/WinStreakLocalizedLogoLayout.ts',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 0,
      y: -430,
      scale: {
        x: 1.3,
        y: 1.3
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: '0b3b1262-fac0-4268-99a4-c27f5ea8f83f',
      stateByName: {
        collectingEvent: {
          visible: false
        },
        race: {
          visible: false
        },
        generic: {
          visible: false
        }
      }
    },
    {
      id: 'd3f81f81-bd53-48c9-ae93-d6030014b878',
      type: 'Container',
      name: 'closeButton',
      className: '',
      x: 329,
      y: -537,
      scale: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      parent: '0b3b1262-fac0-4268-99a4-c27f5ea8f83f'
    },
    {
      id: '50814eab-ac2e-4c74-a8b0-b6612a6bc280',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'Circle',
        x: 0,
        y: 0,
        radius: 100
      },
      texture: 'Shop_Close_Button',
      parent: 'd3f81f81-bd53-48c9-ae93-d6030014b878'
    }
  ],
  x: 0,
  y: 0,
  width: 664,
  height: 667,
  version: '1.0.0',
  stateNames: [
    'generic',
    'race',
    'winStreak',
    'collectingEvent'
  ],
  animations: [
    {
      id: '412c1b60-8b07-4485-bacf-82d11f72a7eb',
      name: 'showCloseButton',
      playingSpeed: 1,
      totalDuration: 200,
      blocks: [
        {
          id: 'af0bf9b0-6308-4083-8ef9-78af9fcc950d',
          type: 'Tween',
          name: 'TWEEN_closeButton',
          duration: 200,
          track: 2,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 0,
          sourceName: 'closeButton',
          easing: 'CubicOut',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class BackstopImagesLayout {
  static raw = raw;
  root!: Container & { data: typeof raw['list'][0]['data'] };
  blackBackground!: Sprite & { data: typeof raw['list'][1]['data'] };
  content!: Container & { data: typeof raw['list'][2]['data'] };
  adCountdownSlot!: Container & { data: typeof raw['list'][3]['data'] };
  genericImage!: Sprite;
  genericText!: Text & { data: typeof raw['list'][5]['data'] };
  raceLocalizedTitle!: RaceEventTitleLocalizationsLayout;
  winStreakLocalizedTitle!: WinStreakLocalizedLogoLayout;
  closeButton!: Container;
  dynamicProps_SPL!: (Container & { data: typeof raw['list'][0]['data'] } | Sprite & { data: typeof raw['list'][1]['data'] } | Container & { data: typeof raw['list'][2]['data'] } | Container & { data: typeof raw['list'][3]['data'] })[];
  StateName!: 'generic' | 'race' | 'winStreak' | 'collectingEvent';

  constructor() {
    populate(this, raw);
  }
}

export abstract class showCloseButton {
  Layout: {
    closeButton: object;
  };

  BlockTypeByName: {
    TWEEN_closeButton: object;
  };

  flowData = raw.animations[0];
}
